export const ChatIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} {...props}>
        <path
            d="M7 .002a7.008 7.008 0 0 0-7 7 6.935 6.935 0 0 0 .792 3.173l-.759 2.717a.893.893 0 0 0 1.079 1.079l2.719-.759a6.934 6.934 0 0 0 3.169.79 7 7 0 1 0 0-14Zm0 1.05a5.95 5.95 0 1 1-2.89 11.15.525.525 0 0 0-.4-.047l-2.585.721.722-2.584a.525.525 0 0 0-.047-.4A5.947 5.947 0 0 1 7 1.05Zm-2.975 4.2a.525.525 0 1 0 0 1.05h5.95a.525.525 0 1 0 0-1.05Zm0 2.45a.525.525 0 1 0 0 1.05h4.55a.525.525 0 1 0 0-1.05Z"
            fill="#98a0ac"
        />
    </svg>
)